import { LVStrings } from "@my-dld/assets/strings";
import ServiceDescriptions from "@my-dld/assets/strings/svc_description";
import { MyRequestsService, MyRequestsServiceItem } from "@10x/coreapp/MyRequestsService";
import { showRVRequests } from "./NavigationUtils";

const RentalValuation: MyRequestsServiceItem = {
	id: "rental_valuation",
	label: LVStrings.rental_evaluation,
	action: serviceHandler,
	descriptionProvider: ServiceDescriptions,
	allowUnverifiedEmailUsers: true,
};

export function registerMyRequestsService( service: MyRequestsService ) {
	service.registerService( RentalValuation );
}

function serviceHandler( service: MyRequestsServiceItem, options?: any ) {
	showRVRequests();
}
